import validate, { checkRequiredField } from 'common/formValidation/lib';
import { validators as customisationValidators } from '../../common/simulationDetails/CustomisationForm';

const formValidate = validate([
    checkRequiredField('name'),
    ...customisationValidators,
]);

export default formValidate;
